jQuery('.js-woocommerce-checkout-form').on('click', (e) => {
  e.preventDefault()
  jQuery('html, body').animate({
    scrollTop: jQuery(jQuery(e.target).data('target')).offset().top - 200
  }, {
    duration: 500
  })
})
